import { initializeApp } from "firebase/app";
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager, CACHE_SIZE_UNLIMITED } from "firebase/firestore";
import { initializeAuth, indexedDBLocalPersistence } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyD4ate0xNBUnwSDsGm5I_3348SfCbNOoeY",
  authDomain: "copiapocr.firebaseapp.com",
  projectId: "copiapocr",
  storageBucket: "copiapocr.firebasestorage.app",
  messagingSenderId: "299278975555",
  appId: "1:299278975555:web:3f2eadeda287e31eb38af6",
  measurementId: "G-16KYJP723G",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager(),
    cacheSizeBytes: CACHE_SIZE_UNLIMITED,
  }),
});
const auth = initializeAuth(app, {
  persistence: indexedDBLocalPersistence,
});
export { db, auth };
